// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"06a4b3fd","122":"06a4b3fd","156":"06a4b3fd","243":"06a4b3fd","456":"06a4b3fd","502":"06a4b3fd","506":"06a4b3fd","987":"06a4b3fd"}[chunkId] + ".chunk.css";
};